import React from 'react';

const COVERAGE_ITEMS = [
  { icon: '🏥', title: 'Medical Cover', desc: 'Up to KES 500,000 for accident-related injuries', highlight: true },
  { icon: '🚗', title: 'Vehicle Damage', desc: 'Third-party vehicle damage up to KES 1,000,000', highlight: false },
  { icon: '📦', title: 'Cargo Protection', desc: 'Lost or damaged delivery items up to KES 50,000', highlight: false },
  { icon: '⚖️', title: 'Legal Liability', desc: 'Legal costs and third-party liability coverage', highlight: false },
  { icon: '💀', title: 'Life Insurance', desc: 'KES 2,000,000 death benefit for your family', highlight: true },
  { icon: '🏠', title: 'Income Protection', desc: '60% income replacement during recovery', highlight: false },
];

const PLANS = [
  {
    id: 'basic',
    name: 'Basic Shield',
    price: 'KES 500/mo',
    desc: 'Essential coverage for new drivers',
    features: ['Medical Cover', 'Vehicle Damage', 'Legal Liability'],
    color: '#e5e7eb',
    textColor: '#374151',
  },
  {
    id: 'premium',
    name: 'Premium Shield',
    price: 'KES 1,200/mo',
    desc: 'Full protection for serious drivers',
    features: ['All Basic features', 'Cargo Protection', 'Life Insurance', 'Income Protection'],
    color: 'linear-gradient(135deg, #ffd700, #f59e0b)',
    textColor: '#0a1628',
    recommended: true,
  },
];

const InsuranceStep = ({ data, onChange, onNext, onBack }) => {
  const selectedPlan = data?.insurancePlan || 'premium';

  return (
    <div className="max-w-lg mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-3">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center text-lg"
            style={{ background: 'linear-gradient(135deg, #0a1628, #1a2d4a)' }}
          >
            🛡️
          </div>
          <div>
            <h2 className="text-2xl font-bold" style={{ color: '#0a1628' }}>
              OnTheGo Shield
            </h2>
            <p className="text-xs font-semibold" style={{ color: '#f59e0b' }}>
              Comprehensive Driver Insurance
            </p>
          </div>
        </div>
        <p className="text-gray-500 text-sm">
          Protect yourself, your vehicle, and your income with OnTheGo Shield — insurance built
          specifically for gig economy drivers.
        </p>
      </div>
      {/* Coverage Grid */}
      <div className="grid grid-cols-2 gap-3 mb-6">
        {COVERAGE_ITEMS?.map((item) => (
          <div
            key={item?.title}
            className="rounded-xl p-3 transition-all duration-200"
            style={{
              background: item?.highlight ? 'rgba(255,215,0,0.08)' : '#f9fafb',
              border: `1px solid ${item?.highlight ? 'rgba(255,215,0,0.3)' : '#e5e7eb'}`,
            }}
          >
            <span className="text-xl">{item?.icon}</span>
            <p className="font-bold text-xs mt-1.5" style={{ color: '#0a1628' }}>
              {item?.title}
            </p>
            <p className="text-xs text-gray-400 mt-0.5 leading-tight">{item?.desc}</p>
          </div>
        ))}
      </div>
      {/* Plan Selection */}
      <h3 className="font-bold text-sm mb-3" style={{ color: '#0a1628' }}>
        Choose Your Plan
      </h3>
      <div className="space-y-3 mb-6">
        {PLANS?.map((plan) => (
          <div
            key={plan?.id}
            className="rounded-xl p-4 cursor-pointer transition-all duration-200 relative"
            style={{
              background: selectedPlan === plan?.id ? 'rgba(255,215,0,0.08)' : 'white',
              border: `2px solid ${selectedPlan === plan?.id ? '#ffd700' : '#e5e7eb'}`,
            }}
            onClick={() => onChange('insurancePlan', plan?.id)}
          >
            {plan?.recommended && (
              <div
                className="absolute -top-2.5 left-4 px-3 py-0.5 rounded-full text-xs font-bold"
                style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
              >
                Recommended
              </div>
            )}
            <div className="flex items-start gap-3">
              <div
                className="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-200"
                style={{
                  borderColor: selectedPlan === plan?.id ? '#ffd700' : '#d1d5db',
                  background: selectedPlan === plan?.id ? '#ffd700' : 'white',
                }}
              >
                {selectedPlan === plan?.id && (
                  <div className="w-2 h-2 rounded-full" style={{ background: '#0a1628' }} />
                )}
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <span className="font-bold text-sm" style={{ color: '#0a1628' }}>
                    {plan?.name}
                  </span>
                  <span className="font-bold text-sm" style={{ color: '#f59e0b' }}>
                    {plan?.price}
                  </span>
                </div>
                <p className="text-xs text-gray-400 mt-0.5">{plan?.desc}</p>
                <div className="flex flex-wrap gap-1 mt-2">
                  {plan?.features?.map((f) => (
                    <span
                      key={f}
                      className="text-xs px-2 py-0.5 rounded-full"
                      style={{ background: '#f3f4f6', color: '#6b7280' }}
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onBack}
          className="flex-1 py-3.5 rounded-xl font-bold text-sm border-2 transition-all duration-200 hover:bg-gray-50"
          style={{ borderColor: '#0a1628', color: '#0a1628' }}
        >
          ← Back
        </button>
        <button
          type="button"
          onClick={onNext}
          className="flex-1 py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:opacity-90 active:scale-95 shadow-lg"
          style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
        >
          Continue →
        </button>
      </div>
    </div>
  );
};

export default InsuranceStep;
